<template>
	<div class="card">
		<slot />
	</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.card {
	background: white;
	border-radius: $border-radius;
	max-width: 580px;
	width: 100%;
	display: flex;
	flex-direction: column;

	@include media('>phone') {
		padding: 40px;
		min-height: 50vh;
	}

	@include media('<=phone') {
		padding: 4vw;
	}

	&.center {
		justify-content: center;
	}
}
</style>
